/**
 * A one-line event bus.
 *
 * Polling alone means a badge can sit wrong for up to half a minute after you
 * have just acted. When a screen changes something, it says so here and any
 * badge listening updates immediately. Polling still runs underneath, to catch
 * changes made by somebody else.
 */
const target = new EventTarget();

export const SUPPORT_CHANGED = "support:changed";

export function emitChange(name = SUPPORT_CHANGED) {
  target.dispatchEvent(new Event(name));
}

export function onChange(name, handler) {
  target.addEventListener(name, handler);
  return () => target.removeEventListener(name, handler);
}
